import styled from '@emotion/styled'

export const Header = styled.div`
  font-size: 1.375rem;l
  font-family: Roboto;
`
